import type { StoryType } from "@config";

/**
 * The story's own name, as readers see it.
 *
 * Same precedence as `getStoryDisplayTitle` in dotell-backend
 * `pages/service.js`, which fills the published `<title>` (and, through
 * engagement-bar.js, the Document header title): `settings.title` first,
 * `settings.og.siteName` only for a story that never got a name.
 * `og.siteName` is the deprecated "Public title" — a collaborative deck never
 * persists it (`build-settings-patch.ts`), so after a rename and a reload it
 * still holds the old/template name.
 *
 * `undefined` means "no usable name".
 */
export const getStoryDisplayTitle = (
  settings: StoryType["settings"] | undefined,
): string | undefined => {
  for (const candidate of [settings?.title, settings?.og?.siteName]) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }
  return undefined;
};
